module.exports = "https://cdn.realtymogul.com/static/media/down.c536db5a.svg";